import { render, staticRenderFns } from "./SimpleDataTable.vue?vue&type=template&id=761c7db7&scoped=true&"
import script from "./SimpleDataTable.vue?vue&type=script&lang=js&"
export * from "./SimpleDataTable.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDataTable.vue?vue&type=style&index=0&id=761c7db7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761c7db7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCheckbox,
  VDataTable,
  VDialog,
  VIcon,
  VPagination,
  VSelect,
  VTooltip,
})
